const select = ($sel) => {
    let options = {};

    if ($sel.data('allowCreate')) {
        options.createTag = (params) => {
            if (params.term.length) {
                return {
                    id: params.term,
                    text: params.term,
                    newOption: true
                }
            }
        };

        options.templateResult = (data) => {
            let $result = $("<span></span>").text(data.text);

            if (data.newOption) {
                $result.append(" <em>(new)</em>");
            }

            return $result;
        };

        options.tokenSeparators = [',', ';'];

        options.tags = true;

        options.sorter = data => data.sort((a, b) => {
            return a.text.localeCompare(!!b.newOption || b.text);
        });
    }


    $sel.select2(options);
}


export default select;